import React from 'react'
import styled from 'styled-components'
import Link from '../Link'
import { string, bool } from 'prop-types'
import Svg from '../../Svg'
import { arrowRight } from '../../Svg/elements'

export const TextLinkWrapper = styled.span`
  align-self: center;
  a {
    display: ${({ display }) => display};
    justify-content: ${({ justifyContent }) => justifyContent};
    font-size: 14px;
    color: ${({ theme, color }) => color || theme.colors.white};
    background-color: transparent;
    text-decoration: ${({ underline }) => (underline ? 'underline' : 'none')};
    transition: color 0.2s linear;
    text-transform: ${({ transform }) => transform};
    letter-spacing: 1.25px;
    &:hover {
      color: ${({ hoverColor }) => hoverColor || null};
      text-decoration: none;
    }
    svg {
      margin-top: 5px;
      margin-left: 10px;
    }
  }
`

const IconLink = ({
  url,
  children,
  padding,
  transform = 'uppercase',
  underline = false,
  display = 'flex',
  justifyContent = 'center',
  ...styles
}) => (
  <TextLinkWrapper
    transform={transform}
    underline={underline}
    display={display}
    justifyContent={justifyContent}
    {...styles}
  >
    <Link url={url} padding={padding}>
      {children} <Svg d={arrowRight} width={25} height={10} />
    </Link>
  </TextLinkWrapper>
)

IconLink.propTypes = {
  url: string.isRequired,
  color: string,
  hoverColor: string,
  underline: bool,
  padding: string,
  transform: string,
  display: string,
  justifyContent: string
}
export default IconLink
